import { Injectable } from '@angular/core';
import {EndpointService} from '../endpoints.service';
import {AQH_STA_0, AQH_STA_1} from '../models/input.module';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StaticService {

  constructor(private endpointService: EndpointService) {
  }

  getHorseRegistries() {
    let payload: AQH_STA_0 = {};
    return this.endpointService.aqh_sta_0(payload).pipe(map((data => {
      return data;
    })))
  }

  getMembershipPlans() {
    let payload: AQH_STA_1 = {};
    return this.endpointService.aqh_sta_1(payload).pipe(map((data => {
      return data.data;
    })))
  }

}
